import store from '../store'
import moment from 'moment'

export default (to, from, next) => {
  if (store.getters.authenticated) {
    store.dispatch('refreshUserToken').then((response) => {
      next()
    }, (error) => {
      console.log(error)
      if (moment().add(1, 'hours') <= moment(store.getters.token_expires)) {
        store.commit('setMessage', { type: 'error', text: 'error.generic.1', translate: true })
        window._paq.push(['trackEvent', 'Login', 'Session End', 'Session Timeout'])
      }
      store.dispatch('logout')
    })
  } else {
    next('/')
  }
}
